import { render, staticRenderFns } from "./NotInTimeTheme.vue?vue&type=template&id=86f4196e&scoped=true&"
import script from "./NotInTimeTheme.vue?vue&type=script&lang=js&"
export * from "./NotInTimeTheme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f4196e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VCheckbox,VColorPicker,VRadio,VRadioGroup,VTextField})
